function re(n, e) {
  if (!e)
    return { src: n, attrs: {} };
  let t = 0, r = 0;
  const s = {}, o = [];
  function c(i, h, f, y, _) {
    typeof i != "number" || i <= h || i >= f ? console.warn(`[StoryblokRichText] - ${y.charAt(0).toUpperCase() + y.slice(1)} value must be a number between ${h} and ${f} (inclusive)`) : _.push(`${y}(${i})`);
  }
  if (typeof e == "object") {
    if (typeof e.width == "number" && e.width > 0 ? (s.width = e.width, t = e.width) : console.warn("[StoryblokRichText] - Width value must be a number greater than 0"), e.height && typeof e.height == "number" && e.height > 0 ? (s.height = e.height, r = e.height) : console.warn("[StoryblokRichText] - Height value must be a number greater than 0"), e.loading && ["lazy", "eager"].includes(e.loading) && (s.loading = e.loading), e.class && (s.class = e.class), e.filters) {
      const { filters: i } = e || {}, { blur: h, brightness: f, fill: y, format: _, grayscale: T, quality: A, rotate: S } = i || {};
      h && c(h, 0, 100, "blur", o), A && c(A, 0, 100, "quality", o), f && c(f, 0, 100, "brightness", o), y && o.push(`fill(${y})`), T && o.push("grayscale()"), S && [0, 90, 180, 270].includes(e.filters.rotate || 0) && o.push(`rotate(${S})`), _ && ["webp", "png", "jpeg"].includes(_) && o.push(`format(${_})`);
    }
    e.srcset && (s.srcset = e.srcset.map((i) => {
      if (typeof i == "number")
        return `${n}/m/${i}x0/${o.length > 0 ? `filters:${o.join(":")}` : ""} ${i}w`;
      if (Array.isArray(i) && i.length === 2) {
        const [h, f] = i;
        return `${n}/m/${h}x${f}/${o.length > 0 ? `filters:${o.join(":")}` : ""} ${h}w`;
      } else {
        console.warn("[StoryblokRichText] - srcset entry must be a number or a tuple of two numbers");
        return;
      }
    }).join(", ")), e.sizes && (s.sizes = e.sizes.join(", "));
  }
  let l = `${n}/m/`;
  return t > 0 && r > 0 && (l = `${l}${t}x${r}/`), o.length > 0 && (l = `${l}filters:${o.join(":")}`), {
    src: l,
    attrs: s
  };
}
var v = /* @__PURE__ */ ((n) => (n.DOCUMENT = "doc", n.HEADING = "heading", n.PARAGRAPH = "paragraph", n.QUOTE = "blockquote", n.OL_LIST = "ordered_list", n.UL_LIST = "bullet_list", n.LIST_ITEM = "list_item", n.CODE_BLOCK = "code_block", n.HR = "horizontal_rule", n.BR = "hard_break", n.IMAGE = "image", n.EMOJI = "emoji", n.COMPONENT = "blok", n.TABLE = "table", n.TABLE_ROW = "tableRow", n.TABLE_CELL = "tableCell", n.TABLE_HEADER = "tableHeader", n))(v || {}), $ = /* @__PURE__ */ ((n) => (n.BOLD = "bold", n.STRONG = "strong", n.STRIKE = "strike", n.UNDERLINE = "underline", n.ITALIC = "italic", n.CODE = "code", n.LINK = "link", n.ANCHOR = "anchor", n.STYLED = "styled", n.SUPERSCRIPT = "superscript", n.SUBSCRIPT = "subscript", n.TEXT_STYLE = "textStyle", n.HIGHLIGHT = "highlight", n))($ || {}), J = /* @__PURE__ */ ((n) => (n.TEXT = "text", n))(J || {}), I = /* @__PURE__ */ ((n) => (n.URL = "url", n.STORY = "story", n.ASSET = "asset", n.EMAIL = "email", n))(I || {});
const ne = [
  "area",
  "base",
  "br",
  "col",
  "embed",
  "hr",
  "img",
  "input",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
], oe = (n = {}) => Object.keys(n).map((e) => `${e}="${n[e]}"`).join(" "), ie = (n = {}) => Object.keys(n).map((e) => `${e}: ${n[e]}`).join("; ");
function ae(n) {
  return n.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
}
const O = (n) => Object.fromEntries(Object.entries(n).filter(([e, t]) => t !== void 0));
function D(n, e = {}, t) {
  const r = oe(e), s = r ? `${n} ${r}` : n, o = Array.isArray(t) ? t.join("") : t || "";
  if (n) {
    if (ne.includes(n))
      return `<${s}>`;
  } else return o;
  return `<${s}>${o}</${n}>`;
}
function le(n = {}) {
  const e = /* @__PURE__ */ new Map(), {
    renderFn: t = D,
    textFn: r = ae,
    resolvers: s = {},
    optimizeImages: o = !1,
    keyedResolvers: c = !1
  } = n, l = t !== D, i = (a) => (u, d) => {
    const p = u.attrs || {};
    return d.render(a, p, u.children || null);
  }, h = (a, u) => {
    const { src: d, alt: p, title: m, srcset: w, sizes: b } = a.attrs || {};
    let k = d, R = {};
    if (o) {
      const { src: te, attrs: se } = re(d, o);
      k = te, R = se;
    }
    const ee = {
      src: k,
      alt: p,
      title: m,
      srcset: w,
      sizes: b,
      ...R
    };
    return u.render("img", O(ee));
  }, f = (a, u) => {
    const { level: d, ...p } = a.attrs || {};
    return u.render(`h${d}`, p, a.children);
  }, y = (a, u) => {
    var d, p, m, w;
    const b = u.render("img", {
      src: (d = a.attrs) == null ? void 0 : d.fallbackImage,
      alt: (p = a.attrs) == null ? void 0 : p.alt,
      style: "width: 1.25em; height: 1.25em; vertical-align: text-top",
      draggable: "false",
      loading: "lazy"
    });
    return u.render("span", {
      "data-type": "emoji",
      "data-name": (m = a.attrs) == null ? void 0 : m.name,
      "data-emoji": (w = a.attrs) == null ? void 0 : w.emoji
    }, b);
  }, _ = (a, u) => u.render(
    "pre",
    a.attrs || {},
    u.render("code", {}, a.children || "")
  ), T = (a, u = !1) => ({ text: d, attrs: p }, m) => {
    const { class: w, id: b, ...k } = p || {}, R = u ? {
      class: w,
      id: b,
      style: ie(k) || void 0
    } : p || {};
    return m.render(a, O(R), d);
  }, A = (a) => C(a), S = (a) => {
    const { marks: u, ...d } = a;
    if ("text" in a) {
      if (u)
        return u.reduce(
          (m, w) => A({ ...w, text: m }),
          A({ ...d, children: d.children })
        );
      const p = a.attrs || {};
      if (c) {
        const m = e.get("txt") || 0;
        e.set("txt", m + 1), p.key = `txt-${m}`;
      }
      return r(d.text, p);
    }
    return "";
  }, H = (a, u) => {
    const { linktype: d, href: p, anchor: m, ...w } = a.attrs || {};
    let b = "";
    switch (d) {
      case I.ASSET:
      case I.URL:
        b = p;
        break;
      case I.EMAIL:
        b = `mailto:${p}`;
        break;
      case I.STORY:
        b = p, m && (b = `${b}#${m}`);
        break;
      default:
        b = p;
        break;
    }
    const k = { ...w };
    return b && (k.href = b), u.render("a", k, a.text);
  }, Y = (a, u) => {
    var d, p;
    return console.warn("[StoryblokRichtText] - BLOK resolver is not available for vanilla usage"), u.render("span", {
      blok: (d = a == null ? void 0 : a.attrs) == null ? void 0 : d.body[0],
      id: (p = a.attrs) == null ? void 0 : p.id,
      style: "display: none"
    });
  }, K = (a, u) => {
    const d = {}, p = u.render("tbody", {}, a.children);
    return u.render("table", d, p);
  }, W = (a, u) => {
    const d = {};
    return u.render("tr", d, a.children);
  }, X = (a, u) => {
    const { colspan: d, rowspan: p, colwidth: m, backgroundColor: w, ...b } = a.attrs || {}, k = {
      ...b
    };
    d > 1 && (k.colspan = d), p > 1 && (k.rowspan = p);
    const R = [];
    return m && R.push(`width: ${m}px;`), w && R.push(`background-color: ${w};`), R.length > 0 && (k.style = R.join(" ")), u.render("td", O(k), a.children);
  }, Q = (a, u) => {
    const { colspan: d, rowspan: p, colwidth: m, backgroundColor: w, ...b } = a.attrs || {}, k = {
      ...b
    };
    d > 1 && (k.colspan = d), p > 1 && (k.rowspan = p);
    const R = [];
    return m && R.push(`width: ${m}px;`), w && R.push(`background-color: ${w};`), R.length > 0 && (k.style = R.join(" ")), u.render("th", O(k), a.children);
  }, U = /* @__PURE__ */ new Map([
    [v.DOCUMENT, i("")],
    [v.HEADING, f],
    [v.PARAGRAPH, i("p")],
    [v.UL_LIST, i("ul")],
    [v.OL_LIST, i("ol")],
    [v.LIST_ITEM, i("li")],
    [v.IMAGE, h],
    [v.EMOJI, y],
    [v.CODE_BLOCK, _],
    [v.HR, i("hr")],
    [v.BR, i("br")],
    [v.QUOTE, i("blockquote")],
    [v.COMPONENT, Y],
    [J.TEXT, S],
    [$.LINK, H],
    [$.ANCHOR, H],
    [$.STYLED, T("span", !0)],
    [$.BOLD, T("strong")],
    [$.TEXT_STYLE, T("span", !0)],
    [$.ITALIC, T("em")],
    [$.UNDERLINE, T("u")],
    [$.STRIKE, T("s")],
    [$.CODE, T("code")],
    [$.SUPERSCRIPT, T("sup")],
    [$.SUBSCRIPT, T("sub")],
    [$.HIGHLIGHT, T("mark")],
    [v.TABLE, K],
    [v.TABLE_ROW, W],
    [v.TABLE_CELL, X],
    [v.TABLE_HEADER, Q]
  ]), B = new Map([
    ...U,
    ...Object.entries(s).map(([a, u]) => [a, u])
  ]), Z = () => ({
    render: (a, u = {}, d) => {
      if (c && a) {
        const p = e.get(a) || 0;
        e.set(a, p + 1), u.key = `${a}-${p}`;
      }
      return t(a, u, d);
    },
    originalResolvers: U,
    mergedResolvers: B
  });
  function L(a) {
    const u = B.get(a.type);
    if (!u)
      return console.error("<Storyblok>", `No resolver found for node type ${a.type}`), "";
    const d = Z();
    if (a.type === "text")
      return u(a, d);
    const p = a.content ? a.content.map(C) : void 0;
    return u({
      ...a,
      children: p
    }, d);
  }
  function C(a) {
    return a.type === "doc" ? l ? a.content.map(L) : a.content.map(L).join("") : Array.isArray(a) ? a.map(L) : L(a);
  }
  return {
    render: C
  };
}
let M = !1;
const z = [], F = (n) => new Promise((e, t) => {
  if (typeof window > "u") {
    t(new Error("Cannot load Storyblok bridge: window is undefined (server-side environment)"));
    return;
  }
  if (window.storyblokRegisterEvent = (s) => {
    if (window.location === window.parent.location) {
      console.warn("You are not in Draft Mode or in the Visual Editor.");
      return;
    }
    M ? s() : z.push(s);
  }, document.getElementById("storyblok-javascript-bridge")) {
    e(void 0);
    return;
  }
  const r = document.createElement("script");
  r.async = !0, r.src = n, r.id = "storyblok-javascript-bridge", r.onerror = (s) => t(s), r.onload = (s) => {
    z.forEach((o) => o()), M = !0, e(s);
  }, document.getElementsByTagName("head")[0].appendChild(r);
});
var ce = Object.defineProperty, he = (n, e, t) => e in n ? ce(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, g = (n, e, t) => he(n, typeof e != "symbol" ? e + "" : e, t);
class ue extends Error {
  constructor(e) {
    super(e), this.name = "AbortError";
  }
}
function de(n, e, t) {
  if (!Number.isFinite(e))
    throw new TypeError("Expected `limit` to be a finite number");
  if (!Number.isFinite(t))
    throw new TypeError("Expected `interval` to be a finite number");
  const r = [];
  let s = [], o = 0, c = !1;
  const l = async () => {
    o++;
    const h = r.shift();
    if (h)
      try {
        const y = await n(...h.args);
        h.resolve(y);
      } catch (y) {
        h.reject(y);
      }
    const f = setTimeout(() => {
      o--, r.length > 0 && l(), s = s.filter((y) => y !== f);
    }, t);
    s.includes(f) || s.push(f);
  }, i = (...h) => c ? Promise.reject(
    new Error(
      "Throttled function is already aborted and not accepting new promises"
    )
  ) : new Promise((f, y) => {
    r.push({
      resolve: f,
      reject: y,
      args: h
    }), o < e && l();
  });
  return i.abort = () => {
    c = !0, s.forEach(clearTimeout), s = [], r.forEach(
      (h) => h.reject(() => new ue("Throttle function aborted"))
    ), r.length = 0;
  }, i;
}
const G = (n = "") => n.includes("/cdn/"), pe = (n, e = 25, t = 1) => ({
  ...n,
  per_page: e,
  page: t
}), fe = (n) => new Promise((e) => setTimeout(e, n)), ye = (n = 0, e) => Array.from({ length: n }, e), ge = (n = 0, e = n) => {
  const t = Math.abs(e - n) || 0, r = n < e ? 1 : -1;
  return ye(t, (s, o) => o * r + n);
}, me = async (n, e) => Promise.all(n.map(e)), be = (n = [], e) => n.map(e).reduce((t, r) => [...t, ...r], []), N = (n, e, t) => {
  const r = [];
  for (const s in n) {
    if (!Object.prototype.hasOwnProperty.call(n, s))
      continue;
    const o = n[s];
    if (o == null)
      continue;
    const c = t ? "" : encodeURIComponent(s);
    let l;
    typeof o == "object" ? l = N(
      o,
      e ? e + encodeURIComponent(`[${c}]`) : c,
      Array.isArray(o)
    ) : l = `${e ? e + encodeURIComponent(`[${c}]`) : c}=${encodeURIComponent(o)}`, r.push(l);
  }
  return r.join("&");
}, V = (n) => {
  const e = {
    eu: "api.storyblok.com",
    us: "api-us.storyblok.com",
    cn: "app.storyblokchina.cn",
    ap: "api-ap.storyblok.com",
    ca: "api-ca.storyblok.com"
  };
  return e[n] ?? e.eu;
};
class ve {
  constructor(e) {
    g(this, "baseURL"), g(this, "timeout"), g(this, "headers"), g(this, "responseInterceptor"), g(this, "fetch"), g(this, "ejectInterceptor"), g(this, "url"), g(this, "parameters"), g(this, "fetchOptions"), this.baseURL = e.baseURL, this.headers = e.headers || new Headers(), this.timeout = e != null && e.timeout ? e.timeout * 1e3 : 0, this.responseInterceptor = e.responseInterceptor, this.fetch = (...t) => e.fetch ? e.fetch(...t) : fetch(...t), this.ejectInterceptor = !1, this.url = "", this.parameters = {}, this.fetchOptions = {};
  }
  /**
   *
   * @param url string
   * @param params ISbStoriesParams
   * @returns Promise<ISbResponse | Error>
   */
  get(e, t) {
    return this.url = e, this.parameters = t, this._methodHandler("get");
  }
  post(e, t) {
    return this.url = e, this.parameters = t, this._methodHandler("post");
  }
  put(e, t) {
    return this.url = e, this.parameters = t, this._methodHandler("put");
  }
  delete(e, t) {
    return this.url = e, this.parameters = t ?? {}, this._methodHandler("delete");
  }
  async _responseHandler(e) {
    const t = [], r = {
      data: {},
      headers: {},
      status: 0,
      statusText: ""
    };
    e.status !== 204 && await e.json().then((s) => {
      r.data = s;
    });
    for (const s of e.headers.entries())
      t[s[0]] = s[1];
    return r.headers = { ...t }, r.status = e.status, r.statusText = e.statusText, r;
  }
  async _methodHandler(e) {
    let t = `${this.baseURL}${this.url}`, r = null;
    e === "get" ? t = `${this.baseURL}${this.url}?${N(this.parameters)}` : r = JSON.stringify(this.parameters);
    const s = new URL(t), o = new AbortController(), { signal: c } = o;
    let l;
    this.timeout && (l = setTimeout(() => o.abort(), this.timeout));
    try {
      const i = await this.fetch(`${s}`, {
        method: e,
        headers: this.headers,
        body: r,
        signal: c,
        ...this.fetchOptions
      });
      this.timeout && clearTimeout(l);
      const h = await this._responseHandler(
        i
      );
      return this.responseInterceptor && !this.ejectInterceptor ? this._statusHandler(this.responseInterceptor(h)) : this._statusHandler(h);
    } catch (i) {
      return {
        message: i
      };
    }
  }
  setFetchOptions(e = {}) {
    Object.keys(e).length > 0 && "method" in e && delete e.method, this.fetchOptions = { ...e };
  }
  eject() {
    this.ejectInterceptor = !0;
  }
  /**
   * Normalizes error messages from different response structures
   * @param data The response data that might contain error information
   * @returns A normalized error message string
   */
  _normalizeErrorMessage(e) {
    if (Array.isArray(e))
      return e[0] || "Unknown error";
    if (e && typeof e == "object") {
      if (e.error)
        return e.error;
      for (const t in e) {
        if (Array.isArray(e[t]))
          return `${t}: ${e[t][0]}`;
        if (typeof e[t] == "string")
          return `${t}: ${e[t]}`;
      }
      if (e.slug)
        return e.slug;
    }
    return "Unknown error";
  }
  _statusHandler(e) {
    const t = /20[0-6]/g;
    return new Promise((r, s) => {
      if (t.test(`${e.status}`))
        return r(e);
      const o = {
        message: this._normalizeErrorMessage(e.data),
        status: e.status,
        response: e
      };
      s(o);
    });
  }
}
const q = "SB-Agent", P = {
  defaultAgentName: "SB-JS-CLIENT",
  defaultAgentVersion: "SB-Agent-Version",
  packageVersion: "7.0.0"
}, ke = {
  PUBLISHED: "published"
};
let j = {};
const E = {};
class we {
  /**
   *
   * @param config ISbConfig interface
   * @param pEndpoint string, optional
   */
  constructor(e, t) {
    g(this, "client"), g(this, "maxRetries"), g(this, "retriesDelay"), g(this, "throttle"), g(this, "accessToken"), g(this, "cache"), g(this, "resolveCounter"), g(this, "relations"), g(this, "links"), g(this, "version"), g(this, "richTextResolver"), g(this, "resolveNestedRelations"), g(this, "stringifiedStoriesCache"), g(this, "inlineAssets");
    let r = e.endpoint || t;
    if (!r) {
      const c = e.https === !1 ? "http" : "https";
      e.oauthToken ? r = `${c}://${V(e.region)}/v1` : r = `${c}://${V(e.region)}/v2`;
    }
    const s = new Headers();
    s.set("Content-Type", "application/json"), s.set("Accept", "application/json"), e.headers && (e.headers.constructor.name === "Headers" ? e.headers.entries().toArray() : Object.entries(e.headers)).forEach(([c, l]) => {
      s.set(c, l);
    }), s.has(q) || (s.set(q, P.defaultAgentName), s.set(
      P.defaultAgentVersion,
      P.packageVersion
    ));
    let o = 5;
    e.oauthToken && (s.set("Authorization", e.oauthToken), o = 3), e.rateLimit && (o = e.rateLimit), this.maxRetries = e.maxRetries || 10, this.retriesDelay = 300, this.throttle = de(
      this.throttledRequest.bind(this),
      o,
      1e3
    ), this.accessToken = e.accessToken || "", this.relations = {}, this.links = {}, this.cache = e.cache || { clear: "manual" }, this.resolveCounter = 0, this.resolveNestedRelations = e.resolveNestedRelations || !0, this.stringifiedStoriesCache = {}, this.version = e.version || ke.PUBLISHED, this.inlineAssets = e.inlineAssets || !1, this.client = new ve({
      baseURL: r,
      timeout: e.timeout || 0,
      headers: s,
      responseInterceptor: e.responseInterceptor,
      fetch: e.fetch
    });
  }
  parseParams(e) {
    return e.token || (e.token = this.getToken()), e.cv || (e.cv = E[e.token]), Array.isArray(e.resolve_relations) && (e.resolve_relations = e.resolve_relations.join(",")), typeof e.resolve_relations < "u" && (e.resolve_level = 2), e;
  }
  factoryParamOptions(e, t) {
    return G(e) ? this.parseParams(t) : t;
  }
  makeRequest(e, t, r, s, o) {
    const c = this.factoryParamOptions(
      e,
      pe(t, r, s)
    );
    return this.cacheResponse(e, c, void 0, o);
  }
  get(e, t = {}, r) {
    t || (t = {});
    const s = `/${e}`;
    G(s) && (t.version = t.version || this.version);
    const o = this.factoryParamOptions(s, t);
    return this.cacheResponse(s, o, void 0, r);
  }
  async getAll(e, t = {}, r, s) {
    const o = (t == null ? void 0 : t.per_page) || 25, c = `/${e}`.replace(/\/$/, ""), l = r ?? c.substring(c.lastIndexOf("/") + 1);
    t.version = t.version || this.version;
    const i = 1, h = await this.makeRequest(
      c,
      t,
      o,
      i,
      s
    ), f = h.total ? Math.ceil(h.total / o) : 1, y = await me(
      ge(i, f),
      (_) => this.makeRequest(c, t, o, _ + 1, s)
    );
    return be([h, ...y], (_) => Object.values(_.data[l]));
  }
  post(e, t = {}, r) {
    const s = `/${e}`;
    return this.throttle("post", s, t, r);
  }
  put(e, t = {}, r) {
    const s = `/${e}`;
    return this.throttle("put", s, t, r);
  }
  delete(e, t = {}, r) {
    t || (t = {});
    const s = `/${e}`;
    return this.throttle("delete", s, t, r);
  }
  getStories(e = {}, t) {
    return this._addResolveLevel(e), this.get("cdn/stories", e, t);
  }
  getStory(e, t = {}, r) {
    return this._addResolveLevel(t), this.get(`cdn/stories/${e}`, t, r);
  }
  getToken() {
    return this.accessToken;
  }
  ejectInterceptor() {
    this.client.eject();
  }
  _addResolveLevel(e) {
    typeof e.resolve_relations < "u" && (e.resolve_level = 2);
  }
  _cleanCopy(e) {
    return JSON.parse(JSON.stringify(e));
  }
  _insertLinks(e, t, r) {
    const s = e[t];
    s && s.fieldtype === "multilink" && s.linktype === "story" && typeof s.id == "string" && this.links[r][s.id] ? s.story = this._cleanCopy(this.links[r][s.id]) : s && s.linktype === "story" && typeof s.uuid == "string" && this.links[r][s.uuid] && (s.story = this._cleanCopy(this.links[r][s.uuid]));
  }
  /**
   *
   * @param resolveId A counter number as a string
   * @param uuid The uuid of the story
   * @returns string | object
   */
  getStoryReference(e, t) {
    return this.relations[e][t] ? JSON.parse(this.stringifiedStoriesCache[t] || JSON.stringify(this.relations[e][t])) : t;
  }
  /**
   * Resolves a field's value by replacing UUIDs with their corresponding story references
   * @param jtree - The JSON tree object containing the field to resolve
   * @param treeItem - The key of the field to resolve
   * @param resolveId - The unique identifier for the current resolution context
   *
   * This method handles both single string UUIDs and arrays of UUIDs:
   * - For single strings: directly replaces the UUID with the story reference
   * - For arrays: maps through each UUID and replaces with corresponding story references
   */
  _resolveField(e, t, r) {
    const s = e[t];
    typeof s == "string" ? e[t] = this.getStoryReference(r, s) : Array.isArray(s) && (e[t] = s.map(
      (o) => this.getStoryReference(r, o)
    ).filter(Boolean));
  }
  /**
   * Inserts relations into the JSON tree by resolving references
   * @param jtree - The JSON tree object to process
   * @param treeItem - The current field being processed
   * @param fields - The relation patterns to resolve (string or array of strings)
   * @param resolveId - The unique identifier for the current resolution context
   *
   * This method handles two types of relation patterns:
   * 1. Nested relations: matches fields that end with the current field name
   *    Example: If treeItem is "event_type", it matches patterns like "*.event_type"
   *
   * 2. Direct component relations: matches exact component.field patterns
   *    Example: "event.event_type" for component "event" and field "event_type"
   *
   * The method supports both string and array formats for the fields parameter,
   * allowing flexible specification of relation patterns.
   */
  _insertRelations(e, t, r, s) {
    if (Array.isArray(r) ? r.find((c) => c.endsWith(`.${t}`)) : r.endsWith(`.${t}`)) {
      this._resolveField(e, t, s);
      return;
    }
    const o = e.component ? `${e.component}.${t}` : t;
    (Array.isArray(r) ? r.includes(o) : r === o) && this._resolveField(e, t, s);
  }
  /**
   * Recursively traverses and resolves relations in the story content tree
   * @param story - The story object containing the content to process
   * @param fields - The relation patterns to resolve
   * @param resolveId - The unique identifier for the current resolution context
   */
  iterateTree(e, t, r) {
    const s = (o, c = "") => {
      if (!(!o || o._stopResolving)) {
        if (Array.isArray(o))
          o.forEach((l, i) => s(l, `${c}[${i}]`));
        else if (typeof o == "object")
          for (const l in o) {
            const i = c ? `${c}.${l}` : l;
            (o.component && o._uid || o.type === "link") && (this._insertRelations(o, l, t, r), this._insertLinks(o, l, r)), s(o[l], i);
          }
      }
    };
    s(e.content);
  }
  async resolveLinks(e, t, r) {
    let s = [];
    if (e.link_uuids) {
      const o = e.link_uuids.length, c = [], l = 50;
      for (let i = 0; i < o; i += l) {
        const h = Math.min(o, i + l);
        c.push(e.link_uuids.slice(i, h));
      }
      for (let i = 0; i < c.length; i++)
        (await this.getStories({
          per_page: l,
          language: t.language,
          version: t.version,
          starts_with: t.starts_with,
          by_uuids: c[i].join(",")
        })).data.stories.forEach(
          (h) => {
            s.push(h);
          }
        );
    } else
      s = e.links;
    s.forEach((o) => {
      this.links[r][o.uuid] = {
        ...o,
        _stopResolving: !0
      };
    });
  }
  async resolveRelations(e, t, r) {
    let s = [];
    if (e.rel_uuids) {
      const o = e.rel_uuids.length, c = [], l = 50;
      for (let i = 0; i < o; i += l) {
        const h = Math.min(o, i + l);
        c.push(e.rel_uuids.slice(i, h));
      }
      for (let i = 0; i < c.length; i++)
        (await this.getStories({
          per_page: l,
          language: t.language,
          version: t.version,
          starts_with: t.starts_with,
          by_uuids: c[i].join(","),
          excluding_fields: t.excluding_fields
        })).data.stories.forEach((h) => {
          s.push(h);
        });
      s.length > 0 && (e.rels = s, delete e.rel_uuids);
    } else
      s = e.rels;
    s && s.length > 0 && s.forEach((o) => {
      this.relations[r][o.uuid] = {
        ...o,
        _stopResolving: !0
      };
    });
  }
  /**
   *
   * @param responseData
   * @param params
   * @param resolveId
   * @description Resolves the relations and links of the stories
   * @returns Promise<void>
   *
   */
  async resolveStories(e, t, r) {
    var s, o;
    let c = [];
    if (this.links[r] = {}, this.relations[r] = {}, typeof t.resolve_relations < "u" && t.resolve_relations.length > 0 && (typeof t.resolve_relations == "string" && (c = t.resolve_relations.split(",")), await this.resolveRelations(e, t, r)), t.resolve_links && ["1", "story", "url", "link"].includes(t.resolve_links) && ((s = e.links) != null && s.length || (o = e.link_uuids) != null && o.length) && await this.resolveLinks(e, t, r), this.resolveNestedRelations)
      for (const l in this.relations[r])
        this.iterateTree(
          this.relations[r][l],
          c,
          r
        );
    e.story ? this.iterateTree(e.story, c, r) : e.stories.forEach((l) => {
      this.iterateTree(l, c, r);
    }), this.stringifiedStoriesCache = {}, delete this.links[r], delete this.relations[r];
  }
  async cacheResponse(e, t, r, s) {
    const o = N({ url: e, params: t }), c = this.cacheProvider();
    if (t.version === "published" && e !== "/cdn/spaces/me") {
      const l = await c.get(o);
      if (l)
        return Promise.resolve(l);
    }
    return new Promise(async (l, i) => {
      var h;
      try {
        const f = await this.throttle(
          "get",
          e,
          t,
          s
        );
        if (f.status !== 200)
          return i(f);
        let y = { data: f.data, headers: f.headers };
        if ((h = f.headers) != null && h["per-page"] && (y = Object.assign({}, y, {
          perPage: f.headers["per-page"] ? Number.parseInt(f.headers["per-page"]) : 0,
          total: f.headers["per-page"] ? Number.parseInt(f.headers.total) : 0
        })), y.data.story || y.data.stories) {
          const T = this.resolveCounter = ++this.resolveCounter % 1e3;
          await this.resolveStories(y.data, t, `${T}`), y = await this.processInlineAssets(y);
        }
        t.version === "published" && e !== "/cdn/spaces/me" && await c.set(o, y);
        const _ = this.cache.clear === "onpreview" && t.version === "draft" || this.cache.clear === "auto";
        return t.token && y.data.cv && (_ && E[t.token] && E[t.token] !== y.data.cv && await this.flushCache(), E[t.token] = y.data.cv), l(y);
      } catch (f) {
        if (f.response && f.status === 429 && (r = typeof r > "u" ? 0 : r + 1, r < this.maxRetries))
          return console.log(
            `Hit rate limit. Retrying in ${this.retriesDelay / 1e3} seconds.`
          ), await fe(this.retriesDelay), this.cacheResponse(e, t, r).then(l).catch(i);
        i(f);
      }
    });
  }
  throttledRequest(e, t, r, s) {
    return this.client.setFetchOptions(s), this.client[e](t, r);
  }
  cacheVersions() {
    return E;
  }
  cacheVersion() {
    return E[this.accessToken];
  }
  setCacheVersion(e) {
    this.accessToken && (E[this.accessToken] = e);
  }
  clearCacheVersion() {
    this.accessToken && (E[this.accessToken] = 0);
  }
  cacheProvider() {
    switch (this.cache.type) {
      case "memory":
        return {
          get(e) {
            return Promise.resolve(j[e]);
          },
          getAll() {
            return Promise.resolve(j);
          },
          set(e, t) {
            return j[e] = t, Promise.resolve(void 0);
          },
          flush() {
            return j = {}, Promise.resolve(void 0);
          }
        };
      case "custom":
        if (this.cache.custom)
          return this.cache.custom;
      // eslint-disable-next-line no-fallthrough
      default:
        return {
          get() {
            return Promise.resolve();
          },
          getAll() {
            return Promise.resolve(void 0);
          },
          set() {
            return Promise.resolve(void 0);
          },
          flush() {
            return Promise.resolve(void 0);
          }
        };
    }
  }
  async flushCache() {
    return await this.cacheProvider().flush(), this.clearCacheVersion(), this;
  }
  async processInlineAssets(e) {
    if (!this.inlineAssets)
      return e;
    const t = (r) => {
      if (!r || typeof r != "object")
        return r;
      if (Array.isArray(r))
        return r.map((o) => t(o));
      let s = { ...r };
      s.fieldtype === "asset" && Array.isArray(e.data.assets) && (s = {
        ...s,
        ...e.data.assets.find((o) => o.id === s.id)
      });
      for (const o in s)
        typeof s[o] == "object" && (s[o] = t(s[o]));
      return s;
    };
    return e.data.story && (e.data.story.content = t(e.data.story.content)), e.data.stories && (e.data.stories = e.data.stories.map((r) => (r.content = t(r.content), r))), e;
  }
}
const Te = (n = {}) => {
  const { apiOptions: e } = n;
  if (!e || !e.accessToken) {
    console.error(
      "You need to provide an access token to interact with Storyblok API. Read https://www.storyblok.com/docs/api/content-delivery#topics/authentication"
    );
    return;
  }
  return { storyblokApi: new we(e) };
}, Re = (n) => {
  if (typeof n != "object" || typeof n._editable > "u")
    return {};
  try {
    const e = JSON.parse(
      n._editable.replace(/^<!--#storyblok#/, "").replace(/-->$/, "")
    );
    return e ? {
      "data-blok-c": JSON.stringify(e),
      "data-blok-uid": `${e.id}-${e.uid}`
    } : {};
  } catch {
    return {};
  }
};
let x = "https://app.storyblok.com/f/storyblok-v2-latest.js";
const _e = (n, e, t = {}) => {
  var r;
  const s = !(typeof window > "u") && typeof window.storyblokRegisterEvent < "u", o = new URL((r = window.location) == null ? void 0 : r.href).searchParams.get(
    "_storyblok"
  ), c = o !== null && +o === n;
  if (!(!s || !c)) {
    if (!n) {
      console.warn("Story ID is not defined. Please provide a valid ID.");
      return;
    }
    window.storyblokRegisterEvent(() => {
      new window.StoryblokBridge(t).on(["input", "published", "change"], (l) => {
        var i;
        l && (l.action === "input" && ((i = l.story) == null ? void 0 : i.id) === n ? e(l.story) : (l.action === "change" || l.action === "published") && l.storyId === n && window.location.reload());
      });
    });
  }
}, $e = (n = {}) => {
  var e, t;
  const {
    bridge: r,
    accessToken: s,
    use: o = [],
    apiOptions: c = {},
    bridgeUrl: l
  } = n;
  c.accessToken = c.accessToken || s;
  const i = { bridge: r, apiOptions: c };
  let h = {};
  o.forEach((y) => {
    h = { ...h, ...y(i) };
  }), l && (x = l);
  const f = !(typeof window > "u") && ((t = (e = window.location) == null ? void 0 : e.search) == null ? void 0 : t.includes("_storyblok_tk"));
  return r !== !1 && f && F(x), h;
};
function Ee(n, e) {
  return le(e).render(n);
}
const Ae = () => F(x);
export {
  v as BlockTypes,
  $ as MarkTypes,
  J as TextTypes,
  Te as apiPlugin,
  Ae as loadStoryblokBridge,
  _e as registerStoryblokBridge,
  Ee as renderRichText,
  le as richTextResolver,
  Re as storyblokEditable,
  $e as storyblokInit,
  _e as useStoryblokBridge
};
